import React, { useEffect } from "react";
import { connect } from "react-redux";
import get from "../../utils/get";
import RegisterGroupScreen from "../screens/RegisterGroupScreen";
import * as actions from "../actions/register";

const RegisterGroupContainer = (props) => {
  useEffect(() => {
    props.getOptions();
    // eslint-disable-next-line
  }, []);
  return <RegisterGroupScreen {...props} />;
};

const mapStateToProps = (state) => ({
  isLoading: get(state, "groups.register.isLoading"),
  data: get(state, "groups.register.data"),
});

const mapActionsToProps = { ...actions };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(RegisterGroupContainer);
